import footerSeperator from "../../assets/footer-seperator.svg";
import footerSeperatorDark from "../../assets/footer-seperator-dark.svg";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "../../common/Loader/Loader";

const Footer = () => {
  const broker = import.meta.env.VITE_BROKER;
  const [data, setData] = useState();

  useEffect(() => {
    async function fetchData() {
      try {
        if (!broker) {
          console.error("Missing VITE_BROKER");

          return;
        }

        const module = await import(
          `../../data/${broker.toLowerCase()}/footer.jsx`
        );

        const footerData = module?.FooterData ?? module?.default?.FooterData;

        if (!footerData) {
          console.error("FooterData not found in module", module);

          return;
        }

        setData(footerData);
      } catch (error) {
        console.error("Failed to load footer.jsx", error);
      }
    }

    fetchData();
  }, [broker]);

  if (!data) {
    return <Loader />;
  }

  return (
    <footer className="relative overflow-hidden bg-white pt-20 dark:bg-dark-300">
      <div className="container">
        <div className="mb-20 grid grid-cols-12 max-lg:gap-y-10 max-lg:text-center">
          <div className="col-span-12 lg:col-span-8">
            <img
              src={data.logo}
              alt="logo"
              className="mb-10 inline-block dark:hidden"
              width={data.logoWidth}
              height={data.logoHeight}
            />
            <img
              src={data.logoDark}
              alt="logo dark version"
              className="mb-10 hidden dark:inline-block"
              width={data.logoWidth}
              height={data.logoHeight}
            />
            <p className="max-w-[350px] max-lg:mx-auto">{data.footerText}</p>

            <div className="mt-3 flex gap-3 max-lg:justify-center">
              <NavLink to="https://anpc.ro/ce-este-sal/" target="_blank">
                <img
                  src={data.anpc}
                  alt="anpc"
                  className="inline-block"
                  width={135}
                  height={40}
                />
              </NavLink>
              <NavLink
                to="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO"
                target="_blank"
              >
                <img
                  src={data.sal}
                  alt="sal"
                  className="inline-block"
                  width={135}
                  height={40}
                />
              </NavLink>
              <NavLink to="https://www.asfromania.ro/" target="_blank">
                <img
                  src={data.asf}
                  alt="asf"
                  className="inline-block dark:hidden"
                  width={135}
                  height={0}
                />
                <img
                  src={data.asfLight}
                  alt="asf"
                  className="hidden dark:inline-block"
                  width={135}
                  height={0}
                />
              </NavLink>
            </div>

            {!data.hideNetopia && (
              <div className="mt-3 flex max-lg:justify-center">
                <iframe
                  src="https://mny.ro/npId.html?color=%2348447e&version=orizontal&secret=149832"
                  style={{
                    border: "none",
                    width: "150px",
                    height: "40px",
                    backgroundColor: "#48447e",
                  }}
                  title="NETOPIA Payments"
                ></iframe>
              </div>
            )}
          </div>

          <div className="col-span-12 max-lg:text-center lg:col-span-2">
            <h3 className="mb-8 text-lg font-medium">Descoperă</h3>
            <ul className="[&>*:not(:last-child)]:mb-3">
              {data.utils.map((items) => (
                <li key={items.id}>
                  <NavLink
                    to={items.link}
                    target={items.target}
                    className="relative inline-block overflow-hidden text-base capitalize text-paragraph before:absolute before:bottom-0 before:left-0 before:h-[1px] before:w-full before:origin-right before:scale-x-0 before:bg-paragraph before:transition-transform before:duration-500 before:content-[''] before:hover:origin-left before:hover:scale-x-100 dark:text-white dark:before:bg-white"
                  >
                    {items.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 max-lg:text-center lg:col-span-2">
            <h3 className="mb-8 text-lg font-medium">Contact</h3>
            <p className="mb-3">{data.address}</p>
            <p className="mb-3">
              <NavLink
                to={`mailto:${data.email}`}
                className="relative inline-block overflow-hidden text-base text-paragraph before:absolute before:bottom-0 before:left-0 before:h-[1px] before:w-full before:origin-right before:scale-x-0 before:bg-paragraph before:transition-transform before:duration-500 before:content-[''] before:hover:origin-left before:hover:scale-x-100 dark:text-white dark:before:bg-white"
              >
                {data.email}
              </NavLink>
            </p>

            {data.phones.map((phone) => (
              <p key={phone}>
                <NavLink
                  to={`tel:${phone.split(" ").join("")}`}
                  className="relative inline-block overflow-hidden text-base capitalize text-paragraph before:absolute before:bottom-0 before:left-0 before:h-[1px] before:w-full before:origin-right before:scale-x-0 before:bg-paragraph before:transition-transform before:duration-500 before:content-[''] before:hover:origin-left before:hover:scale-x-100 dark:text-white dark:before:bg-white"
                >
                  {phone}
                </NavLink>
              </p>
            ))}

            <ul className="social-link flex items-center gap-4 max-lg:justify-center">
              {data.socialLinks.map((items) => (
                <li key={items.id}>
                  <NavLink
                    to={items.link}
                    className="transiton-all"
                    target="_blank"
                  >
                    {items.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="seperator">
          <img
            src={footerSeperator}
            alt="footer-seperator"
            className="w-full object-cover dark:hidden max-md:h-[1px]"
          />
          <img
            src={footerSeperatorDark}
            alt="footer-seperator"
            className="hidden w-full object-cover dark:block max-md:h-[1px]"
          />
        </div>

        <div className="py-10 max-lg:text-center">
          <div className="flex max-lg:flex-col lg:items-center">
            <p className="max-lg:mb-10">{data.copyright}</p>
            <ul className="flex items-center gap-15 max-lg:justify-center lg:ml-auto">
              <li>
                <NavLink
                  to="/politica-de-confidentialitate"
                  className="relative inline-block overflow-hidden text-base capitalize text-paragraph before:absolute before:bottom-0 before:left-0 before:h-[1px] before:w-full before:origin-right before:scale-x-0 before:bg-paragraph before:transition-transform before:duration-500 before:content-[''] before:hover:origin-left before:hover:scale-x-100 dark:text-white dark:before:bg-white"
                >
                  Politica de Confidențialitate
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/termeni-si-conditii"
                  className="relative inline-block overflow-hidden whitespace-nowrap text-base capitalize text-paragraph before:absolute before:bottom-0 before:left-0 before:h-[1px] before:w-full before:origin-right before:scale-x-0 before:bg-paragraph before:transition-transform before:duration-500 before:content-[''] before:hover:origin-left before:hover:scale-x-100 dark:text-white dark:before:bg-white"
                >
                  Termeni și Condiții
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
